var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramGroupedAccounts40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grouped-Accounts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "GroupedAccounts",
    transform: "translate(7.000000, 12.000000)",
    fillRule: "nonzero",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.7272727 C0,9.56418734 2.19787486,7 4.90909091,7 C7.62030695,7 9.81818182,9.56418734 9.81818182,12.7272727 L9.81818182,14.4672852 L0,14.4672852 L0,12.7272727 Z",
    id: "Body"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Head",
    cx: 4.90909091,
    cy: 3.27272727,
    r: 3.27272727
  })), /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(16.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Head",
    cx: 4.90909091,
    cy: 3.27272727,
    r: 3.27272727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.7272727 C0,9.56418734 2.19787486,7 4.90909091,7 C7.62030695,7 9.81818182,9.56418734 9.81818182,12.7272727 L9.81818182,14.4672852 L0,14.4672852 L0,12.7272727 Z",
    id: "Body"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Head",
    fill: "#FFFFFF",
    cx: 12.9090909,
    cy: 6.2727273,
    r: 3.27272727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,15.2727273 C8,12.1096419 10.1978749,9.5454545 12.9090909,9.5454545 C15.620307,9.5454545 17.8181818,12.1096419 17.8181818,15.2727273 L17.8181818,17.4672852 L8,17.4672852 L8,15.2727273 Z",
    id: "Body",
    fill: "#FFCC00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramGroupedAccounts40);
export default __webpack_public_path__ + "static/media/pictogramGroupedAccounts40.87ccf187b07603c316428eafc79f4742.svg";
export { ForwardRef as ReactComponent };